import React from "react";
import { SovosBox, SovosButton } from "mosaic-react";
import { useTheme } from "mosaic-react/styles";
import {
    AI_BRAND_GRADIENT_ICON_LEAD,
    aiBrandLinearGradient315,
} from "mosaic-react-platform/shared/aiBrandGradient";

const SOVI_BUTTON_GRADIENT = aiBrandLinearGradient315(AI_BRAND_GRADIENT_ICON_LEAD);

const SoviGradientOutlineButton = ({
    children,
    disabled = false,
    fullWidth = false,
    onClick,
    startIcon,
    sx,
    ...rest
}) => {
    const theme = useTheme();

    return (
        <SovosBox
            sx={{
                background: disabled
                    ? theme.palette.action.disabledBackground
                    : SOVI_BUTTON_GRADIENT,
                borderRadius: 1,
                display: "inline-flex",
                p: "1px",
                width: fullWidth ? "100%" : undefined,
            }}
        >
            <SovosButton
                variant="text"
                size="small"
                startIcon={startIcon}
                onClick={onClick}
                disabled={disabled}
                sx={{
                    bgcolor: "background.paper",
                    color: "primary.main",
                    fontWeight: 600,
                    textTransform: "none",
                    width: fullWidth ? "100%" : undefined,
                    "&:hover": { bgcolor: "action.hover" },
                    ...sx,
                }}
                {...rest}
            >
                {children}
            </SovosButton>
        </SovosBox>
    );
};

export default SoviGradientOutlineButton;
